import { Link, useLocation } from "react-router";
import {
  urlRegisterPlayer,
  urlRegisterPlayerLastName,
  urlRegisterPlayerPhone,
} from "../../../urls";
import { Keyboard } from "../../../components/keyboard";
import { Button } from "@repo/ui/components/button";
import { Container } from "../../../components/container";
import { Title } from "../../../components/title";
import { InputText } from "../../../components/input-text";
import { useState } from "react";
import { cn } from "@repo/ui/lib/utils";
import { useSendEvent } from "../../../hooks/use-send-event";

function LastName() {
  const { state } = useLocation();
  const [lastName, setLastName] = useState(state?.lastName || "");
  const sendEvent = useSendEvent();

  return (
    <Container>
      <Title className="text-2xl!">¿Cuál es tu apellido?</Title>
      <InputText value={lastName} placeholder="Escribe tu apellido..." />
      <Keyboard onChange={setLastName} value={lastName} mode="capitalize" />
      <Button
        asChild
        variant="pos"
        size="4xl"
        className={cn(
          "w-full",
          lastName.length > 2 ? "" : "opacity-50 cursor-not-allowed!"
        )}
        onClick={(e) => {
          if (lastName.length < 3) {
            e.preventDefault();
            return;
          }
          sendEvent("enter_last_name", { lastName });
        }}
      >
        <Link
          to={urlRegisterPlayerPhone()}
          viewTransition
          state={{ ...state, lastName }}
        >
          Continuar
        </Link>
      </Button>
    </Container>
  );
}

export const route = {
  path: urlRegisterPlayerLastName(),
  element: <LastName />,
  handle: {
    backLink: urlRegisterPlayer(),
  },
};
